const de = {
  title: 'Benachrichtigungseinstellungen für Beiträge',
  templateNameLabel: 'Vorlagenname',
  tabs: {
    lockedDepartments: 'Nicht abwählbare Bereiche',
    mailApplications: 'E-Mail-Vorlagenanwendungen',
    articleTemplate: 'E-Mail-Vorlage für Beiträge'
  },
  alerts: {
    templateSaveFailed: 'Das Template konnte nicht gespeichert werden.',
    templateSaveSuccessful: 'Das Template wurde erfolgreich gespeichert.',
    applicationSaveFailed: 'Die Anwendung konnte nicht erstellt werden.',
    applicationSaveSuccessful: 'Die Anwendung wurde erfolgreich erstellt.',
    loadError: 'Die Vorlage konnte nicht geladen werden.',
    noTemplatesFound: 'Für diese Anwendung konnten keine Templates gefunden werden.'
  },
  subheadings: {
    lockedDepartments: 'Nicht abwählbare Bereiche',
    reminderTemplate: 'E-Mail-Template für Erinnerungen',
    applications: 'E-Mail-Vorlagenanwendungen'
  },
  lockedDepartmentsDescription: {
    heading: 'Anleitung',
    content:
      'Wählen Sie hier die Bereiche aus, die von den entsprechenden Benutzergruppen nicht für die Benachrichtigungseinstellungen abgewählt werden können. Die gewählten Bereiche sind dementsprechend "zwangsabonniert".'
  },
  lockedDepartmentsSaveWarning: {
    heading: 'Automatische Speicherung',
    content: 'Achtung! Änderungen, die hier vorgenommen werden, werden automatisch gespeichert.'
  },
  templateDescription: {
    heading: 'Verwendbare Platzhalter',
    content: 'Um das Template zu erstellen, können Sie die folgenden Platzhalter verwenden:',
    articlesReminder: 'Dieses Template wird für die automatischen Erinnerungs-E-Mails verwendet.',
    notifyArticle:
      'Dieses Template wird für die Benachrichtigung für den Empfänger wichtiger Beiträge verwendet.',
    jobOfferActivation:
      'Dieses Template wird für die Benachrichtigung, dass die Stellenanzeige von dem Empfänger aktiv geschaltet wurde, verwendet.',
    jobmarketNewsletter:
      'Dieses Template wird für die Benachrichtigung, dass für den Empfänger neue relevante Stellenangebote erschienen sind, verwendet.',
    remindExpiringJob:
      'Dieses Template wird für die Benachrichtigung, dass das Stellenangebot in 3 Tagen abläuft, verwendet.',
    banEmail:
      'Dieses Template wird für die Benachrichtigung, dass die Firma des Empfängers für den Stellenmarkt gesperrt wurde, verwendet.',
    notifyDisabledCompanyRegistration:
      'Dieses Template wird für die automatischen Erinnerungs-E-Mails, dass die Stellenanzeige vom Empfänger ausläuft, verwendet.',
    notifyDisabledCompany:
      'Dieses Template wird für die Anfrage auf Freischaltung eines Unternehmens verwendet.',
    approveDisabledCompany:
      'Dieses Template wird für die Bestätigung der Freischaltung eines Unternehmens verwendet.',
    invoiceCancelRequest: 'Dieses Template wird für die Änderungsfrage von einer Firma verwendet.',
    calendarInvite:
      'Dieses Template wird für die Bestätigung einer Anmeldung zu einer Veranstaltung verwendet.',
    cancelEventGroup:
      'Dieses Template wird zur Benachrichtigung, dass eine Veranstaltung nicht stattfindet, verwendet.',
    enrollUser:
      'Dieses Template wird für die Benachrichtigung, dass ein Platz in einer Veranstaltung frei geworden ist, verwendet.',
    unenrollUser:
      'Dieses Template wird für die Benachrichtigung, dass der Empfänger aus der Veranstaltung ausgetragen worden ist, verwendet.',
    cancelEvent:
      'Dieses Template wird für die Benachrichtigung, dass eine Veranstaltung abgesagt wurde, verwendet.',
    community_registrationConfirm:
      'Dieses Template wird für die Benachrichtigung, dass ein Account beim Stellenmarkt erfolgreich angelegt wurde, verwendet.',
    intoffice_registrationConfirm:
      'Dieses Template wird für die Benachrichtigung, dass ein Account erfolgreich angelegt wurde, verwendet.',
    community_forgotPassword: 'Dieses Template wird zur Passwortänderung verwendet.',
    intoffice_forgotPassword: 'Dieses Template wird zur Passwortänderung verwendet.',
    newEntitlements:
      'Dieses Template wird zur Bestätigung, dass Entitlements angelegt wurden, verwendet.',
    incompleteModulesInModuleSelection:
      'Dieses Template wird zur Benachrichtigung, dass Modulwahlen mit unvollständigen Modulen nicht aktiviert werden konnten.',
    selectionModuleIsNotTakingPlace:
      'Dieses Template wird zur Benachrichtigung, dass ein Modul nicht stattfindet, verwendet.',
    selectionSignIn:
      'Dieses Template wird zur Benachrichtigung, dass der Empfänger in ein Modul eingetragen wurde, verwendet.',
    selectionSignInByAdmin:
      'Dieses Template wird zur Benachrichtigung, dass der Empfänger in ein Modul von einem Admin eingetragen wurde, verwendet.',
    selectionMoveUp:
      'Dieses Template wird zur Benachrichtigung, dass der Empfänger in ein Modul nachgerückt ist, verwendet.',
    selectionDischarge:
      'Dieses Template wird zur Benachrichtigung, dass der Empfänger sich aus einem Modul ausgetragen hat, verwendet.',
    selectionDischargeByAdmin:
      'Dieses Template wird zur Benachrichtigung, dass der Empfänger von einem Admin aus einem Modul ausgetragen wurde, verwendet.'
  },
  templateVariables: {
    FULLNAME: 'Der volle Name des Empfängers',
    INTERVAL: 'Das eingestellte Zeitintervall des Empfängers in Tagen',
    ARTICLESLIST: 'Die Liste der Beiträge, an die der Empfänger erinnert werden soll',
    ARTICLESCOUNT: 'Die Anzahl der Beiträge, an die der Empfänger erinnert werden soll',
    ARTICLELINK: 'Link zu dem Artikel',
    ARTICLEHEADLINE: 'Überschrift des Artikels',
    OFFERURL: 'Link zur Stellenanzeige',
    JOBOFFERTITLE: 'Name des Stellenangebots',
    JOBOFFERLINKS: 'Liste der Links zu den Stellenangeboten',
    BANREASON: 'Begründung für die Sperrung der Firma',
    CONTACTEMAIL: 'Kontakt-E-Mail',
    COMPANY: 'Name der Firma',
    OFFERID: 'ID des Stellenangebots',
    INVOICEID: 'ID der Rechnung',
    STOKNUMBER: 'StokNummer',
    CANCELREASON: 'Änderungsgrund',
    EVENTTITLE: 'Name des Events',
    EVENTSTARTDATE: 'Startdatum des Events',
    EVENTPLACE: 'Ort der Veranstaltung',
    EVENTLINK: 'Link zum Event',
    EVENTLECTURERNAME: 'Name des Dozenten',
    GROUPTITLE: 'Name der Gruppe',
    EVENTORGANIZER: 'Name des Veranstalters',
    NEWGROUPINFO: 'Information, wenn man sich in einer anderen Gruppe befindet',
    EMAIL: 'E-Mail des Empfängers',
    TOKENURL: 'URL zum Zurücksetzen des Passworts',
    EXPIRESIN: 'Datum, wann der Link seine Gültigkeit verliert',
    ENTITLEMENTS: 'Liste der angelegten Entitlements',
    AWPMLINKS: 'Liste der AWPM-Modulwahlen',
    FWPMLINKS: 'Liste der FWPM-Modulwahlen',
    SELECTION: 'Name der Wahl',
    MODULENAME: 'Name des Moduls',
    DISCHARGEDBYSTUDENTUNTIL: 'Zeit bis zur Ausschreibung des Studenten'
  },
  createTemplate: {
    applicationName: 'Name der Anwendung'
  },
  treeViewLabels: {
    locked: 'Nicht abwählbare Bereiche',
    applications: 'E-Mail-Anwendungen',
    createTemplate: 'Erstellung E-Mail-Template',
    mailTemplates: 'Vorlagen für E-Mail-Templates',
    articles: 'Artikel-Templates',
    jobmarket: 'Stellenmarkt-Templates',
    events: 'Event-Templates',
    users: 'Benutzer-Templates',
    module_selections: 'Modulwahlen-Templates',
    access_handler: 'Zugriffsverwaltungs-Templates'
  },
  validation: {
    invalidString: 'Wert muss ein String sein',
    invalidCharacterLength: 'Wert muss mindestens 1 Zeichen lang sein',
    invalidKey:
      'Der Schlüssel muss mit ### beginnen und enden und mindestens 1 Zeichen dazwischen enthalten'
  }
};

export default de;
export type ArticleMessagesSettingsTranslation = typeof de;
